export const OFFERS_PAGE_SIZE = 10;

export const OFFERS_SEARCH_PARAM = {
  view: 'view',
  /** The offer of the edit and detail view. */
  id: 'id',
  filter: 'filter',
  page: 'page'
} as const;

/** Radix `Select` items cannot have an empty value – stands for "not prefilled". */
export const NO_SELECTION = 'NONE';
